export const validateFileType = (file: File) => {
  const extension = file.name.split('.').pop();
  const supportedFormats = ['docx', 'pdf'];

  return supportedFormats.includes(extension ?? '');
};

export const validateFileSize = (file: File) => {
  const sizeInBytes = file.size;
  const sizeInMb = parseFloat((sizeInBytes / 1024 / 1024).toFixed(2));

  return sizeInMb <= 5;
};

export const validateFileNameSize = (file: File) => file.name.length < 60;

export const bytesToSize = (bytes: number) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))), 10);
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
};
